<template>
	<div class="userinfo" ref="height_top">
		
	</div>
</template>
<script>
export default {
	components: {},
	data() {

		return {
			form: {
				name: '',
			}

		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {

	},
	watch: {

	},
	methods: {
		tableHeight_fun(){
			this.$nextTick(() => {
	            this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 55
	            console.log(this.tableHeight,12122)
	        })
		},
	}
}
</script>
<style lang="less" scoped>
</style>